<span
    class="intro-poup-anchor"
    [sotiPopupTriggerFor]="introPopup"
    [popUpOverlayBackdrop]="false"
    #intoPopupTrigger="sotiPopupTrigger">
</span>
<div class="action-bar-item"
     [class.rc-drawing-paused]="isAnnotationPaused"
     [soti-tooltip]="disableEnableTooltip"
     placement="top"
     [delay]="500"
     (click)="toggleAnnotation()">
     <div class="hd-icon annotation-bar-icon hd-icon-disable-drawing"></div>
</div>
<div class="action-bar-divider"></div>
<div class="action-bar-item"
    [soti-tooltip]="'annotations_Clear_All_Drawings' | xsI18n "
    placement="top"
    [delay]="500"
    [class.action-bar-item-disabled] = "isDisabled"
    (click)="resetAnnotations(true)">
    <div class="hd-icon annotation-bar-icon rc-small-jump-icon hd-icon-clear-drawing"></div>
</div>
<div class="action-bar-item"
    [soti-tooltip]="'annotations_Change_Color' | xsI18n "
    placement="top"
    [delay]="500"
    [class.action-bar-item-disabled]="isColorSelectionDisabled"
    [sotiPopupTriggerFor]="colorPickerPopup"
    [popUpOverlayBackdrop]="false"
    [popUpDisableClick]="isColorSelectionDisabled"
    (popUpOpened)="popupOpen('colorPickerPopup')"
    (popUpClosed)="popupClose()"
    #colorPopupTrigger="sotiPopupTrigger">
    <div class="hd-icon annotation-bar-icon rc-icon-dropper rc-large-jump-icon">
        <span class="hd-icon-color-dropper"></span>
        <span class="hd-icon-dropper-tip"></span>
    </div>
</div>
<div class="action-bar-item"
    [soti-tooltip]="'annotations_Stroke_Weight' | xsI18n "
    placement="top"
    [delay]="500"
    [class.action-bar-item-disabled] = "isStrokeWidthSelectionDisabled"
    [sotiPopupTriggerFor]="strokeWidthPopup"
    [popUpOverlayBackdrop]="false"
    [popUpDisableClick]="isStrokeWidthSelectionDisabled"
    (popUpOpened)="popupOpen('strokeWidthPopup')"
    (popUpClosed)="popupClose()"
    #strokeWidthPopupTrigger="sotiPopupTrigger">
    <div class="hd-icon annotation-bar-icon rc-small-jump-icon hd-icon-stroke-weight"></div>
</div>
<div class="action-bar-item"
    [soti-tooltip]="'annotations_Eraser' | xsI18n "
    placement="top"
    [delay]="500"
    [class.action-bar-item-disabled] = "isDisabled"
    (click)="annotationTool ='eraser'">
    <div class="hd-icon annotation-bar-icon rc-large-jump-icon hd-icon-eraser-tool"></div>
    <span class="rc-active-tool-indicator"
          [class.visible-indicator] = "annotationTool === 'eraser'"></span>
</div>
<div class="action-bar-item"
    [soti-tooltip]="'annotations_Pencil' | xsI18n "
    placement="top"
    [delay]="500"
    [class.action-bar-item-disabled] = "isDisabled"
    (click)="annotationTool = 'pen'">
    <div class="hd-icon annotation-bar-icon rc-large-jump-icon rc-icon-pencil">
        <span class="hd-icon-pencil-tool"></span>
        <span class="hd-icon-pencil-tip"></span>
    </div>
    <span class="rc-active-tool-indicator"
          [class.visible-indicator] = "annotationTool === 'pen'"></span>
</div>
<div class="action-bar-item"
    [soti-tooltip]="'annotations_Laser' | xsI18n "
    placement="top"
    [delay]="500"
    [class.action-bar-item-disabled] = "isDisabled"
    (click)="annotationTool = 'laser'">
    <div class="hd-icon annotation-bar-icon rc-icon-laser rc-large-jump-icon">
        <span class="hd-icon-laser-pointer"></span>
    </div>
    <span class="rc-active-tool-indicator"
          [class.visible-indicator] = "annotationTool === 'laser'"></span>
</div>
<div class="action-bar-divider"></div>
<div class="action-bar-item"
    [soti-tooltip]="'annotations_Change_User_Access' | xsI18n "
    placement="top"
    [delay]="500"
    [class.action-bar-item-disabled] = "isDrawingModeSelectionDisabled"
    [sotiPopupTriggerFor]="operatingModePopup"
    #operatingModeTrigger="sotiPopupTrigger"
    [popUpOverlayBackdrop]="false"
    [popUpDisableClick]="isDrawingModeSelectionDisabled"
    (popUpOpened)="popupOpen('operatingModePopup')"
    (popUpClosed)="popupClose()">
    <div class="hd-icon annotation-bar-icon"
         [class.hd-icon-technician] = "drawingMode === 'adminonly'"
         [class.hd-icon-all-users] = "drawingMode === 'allusers'"></div>
</div>
<div class="action-bar-item"
    [soti-tooltip]="annotationWhiteboardTooltip"
    placement="top"
    [delay]="500"
    [class.action-bar-item-disabled] = "isDisabled"
    (click) = "toggleOperatingMode()">
    <div class="hd-icon annotation-bar-icon "
         [class.hd-icon-swap-device-drawing] = "operatingMode === 'annotation'"
         [class.hd-icon-swap-whiteboard] = "operatingMode === 'whiteboard'"
    ></div>
</div>

<soti-popup #colorPickerPopup="sotiPopup" position="centerBottom">
    <div class="color-swatch-container">
        <span
            *ngFor="let color of colorPalette"
            class="color-swatch-item"
            (click) = "setColor(color, colorPopupTrigger)"
            [class.color-swatch-white-item]="color === '#ffffff'"
            [style.background-color]="color"
            [class.active-color-swatch-item]="color.toUpperCase() === strokeColor.toUpperCase()"></span>
    </div>
</soti-popup>

<soti-popup #strokeWidthPopup="sotiPopup" position="centerBottom">
    <div class="stroke-width-popup">
        <span class="stroke-width-label stroke-width-label-left">{{strokeWidthMin}}</span>
        <mat-slider
            class="stroke-width-slider"
            [min]="strokeWidthMin"
            [max]="strokeWidthMax"
            [step]="strokeWidthStep">
              <input matSliderThumb [value]="strokeWidth" (valueChange)="setStrokeWidth($event, strokeWidthPopup)" #slider/>
          </mat-slider>
        <span class="stroke-width-label stroke-width-label-right">{{strokeWidthMax}}</span>
        <span class="stroke-width-label stroke-width-indicator">{{slider.value}}</span>
    </div>
</soti-popup>

<soti-popup
    #operatingModePopup="sotiPopup" position="centerBottom">
    <div class="operating-mode-popup-container">

        <div class="operating-mode-label">{{ 'annotations_Select_who_can_draw' | xsI18n  }}</div>
        <div class="operating-mode-toggle-container">
            <div
                class="operating-mode-toggle-item"
                [class.operating-mode-toggle-selected-item] = "drawingMode === 'adminonly'"
                (click) = "setDrawingMode('adminonly', operatingModePopup)">
                {{ 'annotations_Technician' | xsI18n  }}
            </div>
            <div
                class="operating-mode-toggle-item"
                [class.operating-mode-toggle-selected-item] = "drawingMode === 'allusers'"
                (click) = "setDrawingMode('allusers', operatingModePopup)">
                {{ 'annotations_Both_Users' | xsI18n  }}

            </div>
        </div>
    </div>
</soti-popup>

<soti-popup #introPopup="sotiPopup" position="centerBottom" offsetY="-10">
    <div class="intro-popup-container">
        <div class="intro-message">
            <span class="intro-image"></span>
            <span class="intro-popup-text">
                {{ 'annotations_Intro_Message' | xsI18n  }}
            </span>
        </div>
        <div class="intro-popup-actions">
            <label class="intro-popup-label">
                <mat-checkbox class="intro-popup-checkbox" [checked]="!showIntro" disableRipple="true"
                    (change)="showIntro = !showIntro">
                    {{ 'annotations_Intro_Popup_Do_not_show_again' | xsI18n }}
                </mat-checkbox>
            </label>
            <div style="margin-top: 20px;">
                <button class="xs-btn btn-primary btn-space" (click)="closeIntroPopup()">
                    {{ 'settings_ok_button' | xsI18n }}
                </button>
            </div>
        </div>
    </div>
</soti-popup>
